import { Observable, Subject } from 'rxjs'

import { WebSocketMessageType } from '@/util/knockautApiClient/constants'
import {
  WebSocketListener,
  WebSocketMessage,
  WebSocketOptions,
} from '@/util/knockautApiClient/interfaces'

import { ProjectEditor } from '../projectEditor'
import { KnockautHandler } from './knockautHandler'

export interface VariableChangedMsg {
  id: number // ID of changed variable
  newValue: any
  hasChanged: boolean
  oldValue: any
  changedAt: number
  lastUpdatedAt: number
  lastChangedAt: number
}

export class WebSocketHandler implements WebSocketListener {
  private knockautHandler: KnockautHandler
  private projectEditor: ProjectEditor
  private isConnected = false
  private variableChangedSubject: Subject<VariableChangedMsg> = new Subject()
  private objectChangedSubject: Subject<WebSocketMessage> = new Subject()

  constructor(knockautHandler: KnockautHandler) {
    this.knockautHandler = knockautHandler
    this.projectEditor = knockautHandler.projectEditor
  }

  getWebsocketOptions(hostinfo: {
    secure: boolean
    host: string
  }): WebSocketOptions {
    return {
      specificUrl: null,
      baseUrl:
        'ws' + (hostinfo.secure ? 's://' : '://') + hostinfo.host + '/api/',
      autoConnect: false,
    }
  }

  /**
   * Provides live updates for any Variable changes
   * @returns Observable
   */
  getVariableChanges(): Observable<VariableChangedMsg> {
    return this.variableChangedSubject.asObservable()
  }

  /**
   * Provides live updates for object changes
   * @returns Observable
   */
  getObjectChanges(): Observable<WebSocketMessage> {
    return this.objectChangedSubject.asObservable()
  }

  onclose = () => {
    this.isConnected = false
  }
  onerror = (ev: Event) => {
    console.warn(ev)
  }
  onmessage = () => {
    // console.log(ev)
  }
  onopen = () => {
    this.isConnected = true
  }
  reconnect = () => {
    // console.log(count)
  }
  reconnectError = () => {
    console.warn('reconnectError')
  }
  onFilteredMessage = (
    messageType: WebSocketMessageType,
    message: WebSocketMessage
  ) => {
    if (messageType === WebSocketMessageType.VM_UPDATE) {
      /**
       * message.Data Response Header
       * Wert
       * Gab es eine Änderung
       * Vorheriger Wert
       * Zeitstempel der Änderung
       * Zeitstempel der letzten Aktualisierung (seit 5.1)
       * Zeitstempel der letzten Änderung (seit 5.1)
       */
      const id = message.SenderID
      const newValue = message.Data[0]
      const hasChanged = message.Data[1] as boolean
      const oldValue = message.Data[2]
      const changedAt = message.Data[3] as number // new Date((message.Data[3] as number) * 1000)
      const lastUpdatedAt = message.Data[4] as number
      const lastChangedAt = message.Data[5] as number

      // TODO: how to filter out our own changes??
      if (hasChanged) {
        this.variableChangedSubject.next({
          id,
          newValue,
          hasChanged,
          oldValue,
          changedAt,
          lastUpdatedAt,
          lastChangedAt,
        })
      }
    } else {
      this.objectChangedSubject.next(message)
    }
  }

  acceptedMessageTypes = [
    WebSocketMessageType.OM_REGISTER,
    WebSocketMessageType.OM_UNREGISTER,
    WebSocketMessageType.OM_CHANGENAME,
    WebSocketMessageType.OM_CHANGESUMMARY,
    WebSocketMessageType.OM_CHANGEPOSITION,
    WebSocketMessageType.VM_UPDATE,
    WebSocketMessageType.OM_CHANGEPOSITION,
    WebSocketMessageType.OM_CHANGEPOSITION,

    // Called when icon of object is changed
    WebSocketMessageType.OM_CHANGEICON,

    // When changing the parent, the following three messages are called in this order, we only need changeparent
    // WebSocketMessageType.OM_CHILDREMOVED,
    WebSocketMessageType.OM_CHANGEPARENT,
    // WebSocketMessageType.OM_CHILDADDED,
  ]
}
